export default __webpack_public_path__ + "static/media/1 icon (1).54ac922f.jpg";